import type { SvgIconComponent } from '@mui/icons-material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import VolunteerActivismOutlinedIcon from '@mui/icons-material/VolunteerActivismOutlined';

const ICON_MAP: Record<string, SvgIconComponent> = {
    AttachMoneyIcon,
    HelpOutlineIcon,
    VerifiedUserOutlinedIcon,
    SchoolOutlinedIcon,
    GroupOutlinedIcon,
    VolunteerActivismOutlinedIcon,
};

export function getElcIcon(name: string): SvgIconComponent | null {
    return ICON_MAP[name] ?? null;
}
